/* ---------- Scroll Animations ---------- */
$.fn.isInViewport = function (yOffset) {
  yOffset = yOffset || 0
  var elementTop = $(this).offset().top + yOffset;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop() + 184;
  var viewportBottom = viewportTop + $(window).height() - 248;

  return elementBottom > viewportTop && elementTop < viewportBottom;
};


$(window).on("resize scroll mouseup load", function () {
  $("[lc-scroll-animation='animate-in-from-top']").each(function() {
    if ($(this).isInViewport(100)) {
      $(this).attr("lc-scroll-animation","animated-in-from-top");  
    }
  })
});

$(window).on("resize scroll mouseup load", function () {
  $("[lc-scroll-animation='animate-in-from-bottom']").each(function() {
    if ($(this).isInViewport(-100)) {
      $(this).attr("lc-scroll-animation","animated-in-from-bottom");  
    }
  })
});

$(window).on("resize scroll mouseup load", function () {
  $("[lc-scroll-animation='animate-in-from-left']").each(function() {
    if ($(this).isInViewport()) {
      $(this).attr("lc-scroll-animation","animated-in-from-left");  
    }
  })
});

$(window).on("resize scroll mouseup load", function () {
  $("[lc-scroll-animation='animate-in-from-right']").each(function() {
    if ($(this).isInViewport()) {
      $(this).attr("lc-scroll-animation","animated-in-from-right");  
    }
  })
});



